"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _ResourcePortal = _interopRequireDefault(require("../ResourcePortal"));
var _TabIcon = _interopRequireDefault(require("./TabIcon"));
var _defaultIcons = _interopRequireDefault(require("./defaultIcons.js"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var AppDefs = window.cccisd.appDefs;

// Tabs for resource portals within the resource center
// e.x. Training, Software Help, etc. Resources under a tab have a tag associated with the tab.
var ResourceTabs = /*#__PURE__*/function (_React$Component) {
  _inherits(ResourceTabs, _React$Component);
  var _super = _createSuper(ResourceTabs);
  function ResourceTabs() {
    var _this;
    _classCallCheck(this, ResourceTabs);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      currentTabTag: _this.props.tabs[0].tag
    });
    _defineProperty(_assertThisInitialized(_this), "resourcePortalRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "setActiveTab", function (e, tag) {
      e && e.preventDefault();
      _this.resourcePortalRef.current.clearFilters();
      _this.setState({
        currentTabTag: tag
      });
      var params = new URLSearchParams(window.location.search.slice(1));
      params.set('tab', tag);
      var tabQuery = params.get('tab');
      window.history.pushState({
        page: 1
      }, '', "".concat(window.location.pathname, "?tab=").concat(tabQuery));
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.initialTab) {
        _this.setState({
          currentTabTag: _this.props.initialTab
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps, prevState) {
      if (prevProps.tabs !== _this.props.tabs) {
        if (_this.props.initialTab) {
          _this.setState({
            currentTabTag: _this.props.initialTab
          });
        } else {
          _this.setState({
            currentTabTag: _this.props.tabs[0].tag
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "hasCustomStyles", function (attribute) {
      var hasStyles = _this.props.displayOptions && _this.props.displayOptions.portal;
      return hasStyles && _this.props.displayOptions.portal[attribute];
    });
    _defineProperty(_assertThisInitialized(_this), "setTabBarStyle", function () {
      var _this$props = _this.props,
        displayOptions = _this$props.displayOptions,
        showTabs = _this$props.showTabs;
      var textColor;
      var borderColor;
      var backgroundColor;
      var display;
      if (_this.hasCustomStyles('tabTextColor')) {
        textColor = displayOptions.portal.tabTextColor;
      }
      if (_this.hasCustomStyles('tabInactiveColor')) {
        backgroundColor = displayOptions.portal.tabInactiveColor;
      }
      if (_this.hasCustomStyles('tabActiveColor')) {
        borderColor = displayOptions.portal.tabActiveColor;
      }
      if (showTabs === false) {
        display = 'none';
      }
      return {
        color: textColor,
        borderColor: borderColor,
        backgroundColor: backgroundColor,
        display: display
      };
    });
    _defineProperty(_assertThisInitialized(_this), "setTabStyle", function (tag) {
      var _this$props2 = _this.props,
        displayOptions = _this$props2.displayOptions,
        tabs = _this$props2.tabs;
      var backgroundColor;
      var textColor;
      var tabFlexBasis = 100 / tabs.length + '%';
      if (_this.hasCustomStyles('tabInactiveColor')) {
        backgroundColor = displayOptions.portal.tabInactiveColor;
      }
      if (tag === _this.state.currentTabTag && _this.hasCustomStyles('tabActiveColor')) {
        backgroundColor = displayOptions.portal.tabActiveColor;
      }
      if (_this.hasCustomStyles('tabTextColor')) {
        textColor = displayOptions.portal.tabTextColor;
      }
      if (tag === _this.state.currentTabTag && _this.hasCustomStyles('tabTextActiveColor')) {
        textColor = displayOptions.portal.tabTextActiveColor;
      }
      return {
        backgroundColor: backgroundColor,
        color: textColor,
        flex: "0 0 ".concat(tabFlexBasis)
      };
    });
    return _this;
  }
  _createClass(ResourceTabs, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        tabs = _this$props3.tabs,
        displayOptions = _this$props3.displayOptions,
        renderResourceTiles = _this$props3.renderResourceTiles;
      var currentTabTag = this.state.currentTabTag;
      var currentTab = this.props.tabs.find(function (item) {
        return item.tag === currentTabTag;
      });
      if (currentTab) {
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].tabs,
          style: this.setTabBarStyle()
        }, tabs.map(function (tab) {
          var icons = AppDefs.resourceCenters.icons || _defaultIcons["default"];
          var tabIcon = icons.find(function (icon) {
            return icon.id === tab.icon;
          });
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: tab.tag,
            role: "presentation",
            className: currentTabTag === tab.tag ? _style["default"].active : '',
            onClick: function onClick(e) {
              return _this2.setActiveTab(e, tab.tag);
            },
            style: _this2.setTabStyle(tab.tag)
          }, tabIcon && tab.icon !== 'none' && /*#__PURE__*/_react["default"].createElement(_TabIcon["default"], {
            icon: tabIcon
          }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            content: tab.label
          })));
        })), /*#__PURE__*/_react["default"].createElement(_ResourcePortal["default"], {
          ref: this.resourcePortalRef,
          id: this.props.id,
          currentTab: currentTabTag,
          tags: this.props.tags,
          topFilterBar: currentTab.topFilterBar,
          filterGroups: currentTab.filterGroups,
          displayOptions: displayOptions,
          renderResourceTiles: renderResourceTiles,
          showTabs: this.props.showTabs
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: true
      });
    }
  }]);
  return ResourceTabs;
}(_react["default"].Component);
exports["default"] = ResourceTabs;
_defineProperty(ResourceTabs, "propTypes", {
  id: _propTypes["default"].string,
  tags: _propTypes["default"].array,
  tabs: _propTypes["default"].array,
  initialTab: _propTypes["default"].string,
  displayOptions: _propTypes["default"].object,
  showTabs: _propTypes["default"].bool,
  renderResourceTiles: _propTypes["default"].func
});